import { forwardRef } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const CONTENT_FONT = 'Arial, Helvetica, sans-serif'

// Applied to the frame and to dialogs opened from it (dialogs render in a
// portal, outside the frame).
export const contentTextSx = {
  fontFamily: CONTENT_FONT,
  textAlign: 'left',
  fontStyle: 'normal',
  '& .MuiTypography-root, & .MuiButton-root, & .MuiFormControlLabel-label, & .MuiFormLabel-root, & .MuiInputBase-root, & .MuiAlert-message, & .MuiChip-label, & .MuiFormHelperText-root':
    { fontFamily: CONTENT_FONT, fontStyle: 'normal' },
  '& .MuiTypography-root, & .MuiFormControlLabel-label, & .MuiFormLabel-root, & .MuiInputBase-root, & .MuiAlert-message, & .MuiButton-root':
    { fontSize: '1.0625rem', lineHeight: 1.6 },
  '& .MuiFormHelperText-root, & .MuiChip-label': { fontSize: '1rem' },
  '& .MuiButton-root': { textTransform: 'none', minHeight: 44 },
  '& a': { color: 'primary.main', textDecoration: 'underline' },
  '& a:focus-visible, & button:focus-visible, & [tabindex]:focus-visible, & .Mui-focusVisible': {
    outline: '3px solid',
    outlineColor: 'primary.main',
    outlineOffset: '2px',
  },
}

// The unbranded reading column used by the assessment, feedback form and
// question bank: Arial, 17px, left aligned, one column up to 760px.
const ContentFrame = ({ children, maxWidth = 760, sx, ...props }) => (
  <Box
    sx={{
      width: '100%',
      maxWidth,
      mx: 'auto',
      px: { xs: 0.5, sm: 2 },
      py: 2,
      boxSizing: 'border-box',
      color: 'text.primary',
      ...contentTextSx,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
)

// Page and section headings. The page heading takes focus when the screen
// changes, so keyboard and screen reader users land at the top of it.
export const PageHeading = forwardRef(({ children, sx, ...props }, ref) => (
  <Typography
    component="h1"
    ref={ref}
    tabIndex={-1}
    sx={{ fontSize: '1.75rem !important', fontWeight: 700, lineHeight: '1.25 !important', mb: 2, outline: 'none', ...sx }}
    {...props}
  >
    {children}
  </Typography>
))
PageHeading.displayName = 'PageHeading'

export const SectionHeading = ({ children, sx, component = 'h2', ...props }) => (
  <Typography
    component={component}
    sx={{ fontSize: '1.3rem !important', fontWeight: 700, lineHeight: '1.3 !important', mt: 3, mb: 1, ...sx }}
    {...props}
  >
    {children}
  </Typography>
)

export default ContentFrame
